import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CacheService } from '@uzurv/core';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VehicleType } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class VehicleTypeService extends UzurvRestService {
  readonly resourceUrl = 'vehicleTypes/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer,
    private cacheService: CacheService
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Removes a vehicle type
   *
   * @param vehicleType
   */
  deleteVehicleType(vehicleType: VehicleType): Observable<boolean> {
    return this.delete<boolean>(`${this.resourceUrl}${vehicleType.id}`);
  }

  /**
   * Updates an existing vehicle type
   *
   * @param vehicleType
   */
  updateVehicleType(vehicleType: VehicleType): Observable<VehicleType> {
    return this.patch<VehicleType>(`${this.resourceUrl}${vehicleType.id}`, Serialize(vehicleType)).pipe(
      map(response => Deserialize(response, VehicleType))
    );
  }

  /**
   * Creates a new vehicle type
   *
   * @param vehicleType
   */
  createVehicleType(vehicleType: VehicleType): Observable<VehicleType> {
    return this.post<VehicleType>(this.resourceUrl, Serialize(vehicleType)).pipe(map(response => Deserialize(response, VehicleType)));
  }
}
